export default __webpack_public_path__ + "static/media/penny_savers.c3b1fe32.jpg";